export const DATE_TIME_FORMAT = [
  {
    label: 'Custom',
    value: 'custom'
  },
  // US Formats (Month/Day/Year)
  {
    label: 'MM/dd/yyyy',
    value: 'MM/dd/yyyy'
  },
  {
    label: 'MM/dd/yy',
    value: 'MM/dd/yy'
  },
  {
    label: 'MM/dd/yyyy HH:mm:ss',
    value: 'MM/dd/yyyy HH:mm:ss'
  },
  {
    label: 'MM/dd/yyyy hh:mm:ss a',
    value: 'MM/dd/yyyy hh:mm:ss a'
  },
  {
    label: 'MM/dd/yy hh:mm a',
    value: 'MM/dd/yy hh:mm a'
  },
  {
    label: 'M/d/yy, HH:mm',
    value: 'M/d/yy, HH:mm'
  },
  {
    label: 'MM-dd-yyyy hh:mm:ss a',
    value: 'MM-dd-yyyy hh:mm:ss a'
  },

  // European Formats (Day/Month/Year)
  {
    label: 'dd/MM/yyyy',
    value: 'dd/MM/yyyy'
  },
  {
    label: 'dd/MM/yy',
    value: 'dd/MM/yy'
  },
  {
    label: 'dd-MM-yyyy',
    value: 'dd-MM-yyyy'
  },
  {
    label: 'dd.MM.yyyy',
    value: 'dd.MM.yyyy'
  },
  {
    label: 'dd.MM.yyyy HH:mm:ss',
    value: 'dd.MM.yyyy HH:mm:ss'
  },
  {
    label: 'dd-MMM-yy',
    value: 'dd-MMM-yy'
  },
  {
    label: 'dd MMM yyyy, HH:mm:ss',
    value: 'dd MMM yyyy, HH:mm:ss'
  },
  {
    label: 'dd MMMM yyyy, HH:mm:ss',
    value: 'dd MMMM yyyy, HH:mm:ss'
  },
  {
    label: 'dd-MM-yyyy HH:mm:ss',
    value: 'dd-MM-yyyy HH:mm:ss'
  },

  // Named Month and Weekday Formats (Common English Formats)
  {
    label: 'MMM d, yyyy',
    value: 'MMM d, yyyy'
  },
  {
    label: 'MMMM d, yyyy',
    value: 'MMMM d, yyyy'
  },
  {
    label: 'EEE, MMM d, yyyy',
    value: 'EEE, MMM d, yyyy'
  },
  {
    label: 'EEEE, MMMM d, yyyy',
    value: 'EEEE, MMMM d, yyyy'
  },

  // ISO / Year-first Formats
  {
    label: 'yyyy/MM/dd',
    value: 'yyyy/MM/dd'
  },
  {
    label: 'yyyy-MM-dd',
    value: 'yyyy-MM-dd'
  },
  {
    label: 'yyyyMMdd',
    value: 'yyyyMMdd'
  },
  {
    label: 'yyyy-MM-dd HH:mm:ss',
    value: 'yyyy-MM-dd HH:mm:ss'
  },
  {
    label: 'yyyy/MM/dd HH:mm:ss',
    value: 'yyyy/MM/dd HH:mm:ss'
  },

  // Localized Formats (e.g., Japanese)
  {
    label: 'yyyy年MM月dd日',
    value: 'yyyy年MM月dd日'
  },
  {
    label: 'yyyy年MM月dd日 HH時mm分ss秒',
    value: 'yyyy年MM月dd日 HH時mm分ss秒'
  }

// {
//     label: 'EEEE, dd MMMM yyyy, HH:mm:ss',
//     value: 'EEEE, dd MMMM yyyy, HH:mm:ss'
// },

// {
//     label: 'MMM d, y, h:mm:ss a',
//     value: 'MMM d, y, h:mm:ss a'
// },

// Built-in Angular formats
// {
//     label: 'M/d/yy, h:mm a',
//     value: 'short'
// },
// {
//     label: 'M/d/yy',
//     value: 'shortDate'
// },
// {
//     label: 'h:mm a',
//     value: 'shortTime'
// },

// {
//     label: 'MMM d, y, h:mm:ss a',
//     value: 'medium'
// },
// {
//     label: 'MMM d, y',
//     value: 'mediumDate'
// },
// {
//     label: 'h:mm:ss a',
//     value: 'mediumTime'
// },

// {
//     label: 'MMMM d, y',
//     value: 'longDate'
// },
// {
//     label: 'h:mm:ss a z',
//     value: 'longTime'
// },

// {
//     label: 'EEEE, MMMM d, y',
//     value: 'fullDate'
// },
// {
//     label: 'h:mm:ss a zzzz',
//     value: 'fullTime'
// }
];